import { Facebook, Instagram, Linkedin } from "lucide-react";

const LINKS = [
  { label: "Website", href: "https://dolphin-digital.com/", testid: "footer-link-website" },
  { label: "Live Map", href: "https://map.dolphin-one.com/", testid: "footer-link-live-map" },
  { label: "Contact Us", href: "https://dolphin-digital.com/contact-us", testid: "footer-link-contact-us" },
];

const SOCIALS = [
  {
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/dolphinDigitalUSA",
    testid: "social-facebook-link",
  },
  {
    icon: Instagram,
    label: "Instagram",
    href: "https://www.instagram.com/dolphindigitalusa/",
    testid: "social-instagram-link",
  },
  {
    icon: Linkedin,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/dolphindigital/",
    testid: "social-linkedin-link",
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-white/10 bg-[#08080c] pt-20"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col gap-12 pb-16 md:flex-row md:items-start md:justify-between">
          <div>
            <img
              src="/logo.webp"
              alt="Dolphin Retail Media"
              data-testid="footer-logo"
              className="h-10 w-auto"
            />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/50">
              The Retail Media Network Built for the Physical World.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Resources</h4>
            <ul className="mt-5 flex flex-col gap-3">
              {LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={link.testid}
                    className="text-sm text-white/50 transition-colors duration-200 hover:text-white"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-6 border-t border-white/10 py-8 md:flex-row">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <p data-testid="footer-copyright" className="text-xs text-white/40">
              &copy; {year} Dolphin. All rights reserved.
            </p>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              data-testid="footer-terms-link"
              className="text-xs text-white/40 transition-colors duration-200 hover:text-white"
            >
              Terms of Service
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              data-testid="footer-privacy-link"
              className="text-xs text-white/40 transition-colors duration-200 hover:text-white"
            >
              Privacy Policy
            </a>
          </div>
          <div className="flex items-center gap-3">
            {SOCIALS.map(({ icon: Icon, label, href, testid }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={testid}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-white/50 transition-[color,border-color,background-color] duration-300 hover:border-[#e0359e]/40 hover:bg-[#e0359e]/10 hover:text-white"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
